import styled from 'styled-components';

interface MainProps {
  $isNavCollapsed: boolean;
}

export const Main = styled.main<MainProps>`
  box-sizing: border-box;
  width: calc(100% - ${({ $isNavCollapsed }) => $isNavCollapsed ? '48px' : '228px'});
  height: 100vh;
  margin-left: ${({ $isNavCollapsed }) => $isNavCollapsed ? '48px' : '228px'};
  padding-top: 48px;
  overflow: auto;
  background-color: rgb(242, 242, 242);
  transition: width 0.2s, margin-left 0.2s;
`;
